export default __webpack_public_path__ + "static/APP_2_1-4d90ecafe1b0de70415eccd214b3a626.png";